// src/components/AppProviders.tsx
// The sign-in session (auth/session.ts) for useSession and RequireAuth, and
// the data loads that wait on it.
import { ReactNode } from "react";
import { SessionProvider } from "@jkast90/kast-common/auth";
import { session } from "../auth/session";
import { ReduxInitializer } from "./ReduxInitializer";

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <SessionProvider session={session}>
      <ReduxInitializer>{children}</ReduxInitializer>
    </SessionProvider>
  );
}
